export default __webpack_public_path__ + "static/media/updated_users.3a9d4f46.svg";